// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-box {
  position: relative;
  width: 100%;
  z-index: 1;
}

.input-box .text {
  display: block;
  box-sizing: border-box;
  width: 100%;
  border: none;
  padding: 2px 20px 2px 0px;
  /* Add right padding for clear button */

  background-color: transparent;
  stroke-width: 1px;
  stroke-color: var(--border-input);
  border-radius: 4px;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-input-2);

  /* Enable ellipsis for both text and placeholder */
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: var(--text-input-placeholder);
    opacity: 1;
    /* Force placeholder to behave like text */
    -webkit-text-fill-color: var(--text-input-placeholder);
    -webkit-opacity: 1;
  }

  &:focus::placeholder {
    color: transparent;
    -webkit-text-fill-color: transparent;
  }
}

.input-box .btn {
  padding: 0px;

  position: absolute;
  top: 0;
  bottom: 0;
  right: 12px;
  display: flex;
  align-items: center;

  background-color: transparent;
  border: none;
  cursor: pointer;

  &:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: var(--accent-secondary);
    }
  }
}

/* Dropdown styles */
.input-box-dropdown {
  width: 100%;
  position: absolute;
  top: 42px;
  left: 0;
  right: 0;
  background-color: var(--surface-primary);
  box-shadow: 0 0 12px 0 var(--box-shadow-primary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  z-index: 1000;
  margin-top: 2px;
  padding: 8px 0;
}

.input-box-dropdown-container {
  max-height: 200px;
  overflow-y: auto;
}

.input-box-dropdown-container::-webkit-scrollbar {
  width: 4px;
}

.input-box-dropdown-container::-webkit-scrollbar-thumb {
  background-color: var(--surface-disabled);
  border-radius: 2px;
}

.input-box-dropdown-container::-webkit-scrollbar-track {
  background-color: transparent;
}

.input-box-dropdown-item {
  box-sizing: border-box;
  /*height: 32px;*/
  /*padding: 4px 8px;*/
  cursor: pointer;
  text-align: left;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-primary);

  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--color-brand-hover2);
  }

  &.selected {
    background-color: #e3f2fd;
    color: #1976d2;
  }

  &.loading {
    text-align: center;
    color: var(--accent-secondary);
    font-style: italic;
    cursor: default;

    &:hover {
      background-color: transparent;
    }
  }

  &.no-results {
    text-align: center;
    color: var(--text-secondary);
    font-size: 16px;
    padding: 24px 0;
    font-style: italic;
    cursor: default;

    &:hover {
      background-color: transparent;
    }
  }

  &:last-child {
    border-bottom: none;
  }
}

.input-box-dropdown-item-content {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  height: 56px;
  /* height: 60px; */
  /* max-height: 60px; */
  gap: 8px;
}

.input-box-dropdown-item-content-text {
  display: flex;
  flex-direction: column;
}

.input-box-dropdown-item-content-text-symbol {
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
}

.input-box-dropdown-item-content-text-name {
  font-size: 12px;
  line-height: 20px;
}

.input-box-dropdown-item-content-flag {
  width: 24px;
  height: 24px;

  svg {
    width: 24px;
    height: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/RicInputBox/RicInputBox.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;;EAEvC,6BAA6B;EAC7B,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;;EAE1B,kDAAkD;EAClD,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;;EAEhB;IACE,aAAa;EACf;;EAEA;IACE,oCAAoC;IACpC,UAAU;IACV,0CAA0C;IAC1C,sDAAsD;IACtD,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;EACtC;AACF;;AAEA;EACE,YAAY;;EAEZ,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;;EAEnB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;;EAEf;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;;IAEZ;MACE,6BAA6B;IAC/B;EACF;AACF;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,wCAAwC;EACxC,gDAAgD;EAChD,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;;EAE1B,sCAAsC;;EAEtC;IACE,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;;IAEf;MACE,6BAA6B;IAC/B;EACF;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,eAAe;;IAEf;MACE,6BAA6B;IAC/B;EACF;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".input-box {\n  position: relative;\n  width: 100%;\n  z-index: 1;\n}\n\n.input-box .text {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  border: none;\n  padding: 2px 20px 2px 0px;\n  /* Add right padding for clear button */\n\n  background-color: transparent;\n  stroke-width: 1px;\n  stroke-color: var(--border-input);\n  border-radius: 4px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-input-2);\n\n  /* Enable ellipsis for both text and placeholder */\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  &:focus {\n    outline: none;\n  }\n\n  &::placeholder {\n    color: var(--text-input-placeholder);\n    opacity: 1;\n    /* Force placeholder to behave like text */\n    -webkit-text-fill-color: var(--text-input-placeholder);\n    -webkit-opacity: 1;\n  }\n\n  &:focus::placeholder {\n    color: transparent;\n    -webkit-text-fill-color: transparent;\n  }\n}\n\n.input-box .btn {\n  padding: 0px;\n\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 12px;\n  display: flex;\n  align-items: center;\n\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n\n  &:focus {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n\n  svg {\n    width: 16px;\n    height: 16px;\n\n    path {\n      fill: var(--accent-secondary);\n    }\n  }\n}\n\n/* Dropdown styles */\n.input-box-dropdown {\n  width: 100%;\n  position: absolute;\n  top: 42px;\n  left: 0;\n  right: 0;\n  background-color: var(--surface-primary);\n  box-shadow: 0 0 12px 0 var(--box-shadow-primary);\n  border: 1px solid var(--border-primary);\n  border-radius: 4px;\n  z-index: 1000;\n  margin-top: 2px;\n  padding: 8px 0;\n}\n\n.input-box-dropdown-container {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.input-box-dropdown-container::-webkit-scrollbar {\n  width: 4px;\n}\n\n.input-box-dropdown-container::-webkit-scrollbar-thumb {\n  background-color: var(--surface-disabled);\n  border-radius: 2px;\n}\n\n.input-box-dropdown-container::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.input-box-dropdown-item {\n  box-sizing: border-box;\n  /*height: 32px;*/\n  /*padding: 4px 8px;*/\n  cursor: pointer;\n  text-align: left;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-primary);\n\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: var(--color-brand-hover2);\n  }\n\n  &.selected {\n    background-color: #e3f2fd;\n    color: #1976d2;\n  }\n\n  &.loading {\n    text-align: center;\n    color: var(--accent-secondary);\n    font-style: italic;\n    cursor: default;\n\n    &:hover {\n      background-color: transparent;\n    }\n  }\n\n  &.no-results {\n    text-align: center;\n    color: var(--text-secondary);\n    font-size: 16px;\n    padding: 24px 0;\n    font-style: italic;\n    cursor: default;\n\n    &:hover {\n      background-color: transparent;\n    }\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.input-box-dropdown-item-content {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  height: 56px;\n  /* height: 60px; */\n  /* max-height: 60px; */\n  gap: 8px;\n}\n\n.input-box-dropdown-item-content-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.input-box-dropdown-item-content-text-symbol {\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.input-box-dropdown-item-content-text-name {\n  font-size: 12px;\n  line-height: 20px;\n}\n\n.input-box-dropdown-item-content-flag {\n  width: 24px;\n  height: 24px;\n\n  svg {\n    width: 24px;\n    height: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
